import LoadingOverlay from '@/components/LoadingOverlay.vue'

export default {
  components: {
    LoadingOverlay
  },

  data () {
    return {
      busy: false,
      error: null,
      lastPromise: null
    }
  },

  methods: {
    async ajaxCall (promise) {
      try {
        this.ajaxReset({
          busy: true,
          lastPromise: promise
        })

        return await promise
      } catch (err) {
        this.error = err.message
      } finally {
        this.busy = false
      }
    },

    ajaxReset ({ busy = false, error = null, lastPromise = null }) {
      this.busy = busy
      this.error = error
      this.lastPromise = lastPromise
    }
  }
}
